export default {
	qty: 4,
	wheel: null,
	selected: {},
	viewed: {}
}